import React, { useContext, useEffect } from "react";
import Container from "react-bootstrap/Container";
import { jobsGet, selectedJob } from "../../../slices/jobs/jobManagementSlice";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../slices/store";
import { JobCardContent } from "../../../utils/helpers/helperDataset/jobs-management-contents/cardContent";
import { IUserResponse } from "../../../app/common-models/IUserResponse";
import { scrollToTop } from "../../../utils/helpers/helperMethods/scrollToTop";
import FilterSection from "../../user-management/components/FilterSection";
import { handleDeleteJobService } from "../service/JobsService";
import { TodosContext } from "../../../context";
import { Link, useNavigate } from "react-router-dom";
import UseAuthConfig from "../../../hooks/useAuthConfig";
import BreadCrumb from "../../../components/organisms/Breadcrumb/BreadCrumb";
import Headline from "../../../components/organisms/Headline/Headline";
import Loader from "../../../components/atoms/Loader/Loader";
import FullWidthCard, {
  CardContentItem,
} from "../../../components/organisms/Cards/full-width-card/FullWidthCard";
import SearchHelper from "../../../components/organisms/Cards/user-card-controller/SearchHelper";
import useDebouncedDispatch from "../../../utils/DebouncedDispatch";
import Pagination from "../../../components/molecules/Pagination/Pagination";
import Button from "../../../components/atoms/Buttons/Button/Button";

const ListOfJobs = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { protectedResources }: any = UseAuthConfig();
  const status = useSelector((state: RootState) => state.jobsManagement.status);
  const requestedJobs = useSelector(
    (state: RootState) => state.jobsManagement.jobs
  );
  const [requestedJobsData, setRequestedJobsData] =
    React.useState<IUserResponse>(requestedJobs);
  const [clickFilterStatus, setClickFilterStatus] = React.useState(false);
  const [clickFilterSearch, setClickFilterSearch] = React.useState(false);
  const [paginationChanged, setPaginationChanged] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(false);
  const { addAlert } = useContext(TodosContext);
  const navigate = useNavigate();
  const [jobRequests, setJobRequest] = React.useState({
    PageNumber: 1,
    SearchText: "",
    SortOrder: 1,
    PageSize: 5,
    OrderBy: "",
    ParameterOne: "",
    ParameterTwo: "",
    ParameterThree: "",
    url: protectedResources.apiTodoList.endpoint,
    accessToken: localStorage.getItem("AccessToken") || "llll",
  });
  const debouncedDispatch = useDebouncedDispatch(dispatch);

  useEffect(() => {
    setIsLoading(true);
    if (jobRequests) {
      dispatch(jobsGet(jobRequests));
    }
    scrollToTop();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setRequestedJobsData(requestedJobs);
    setIsLoading(false);
  }, [requestedJobs]);

  useEffect(() => {
    if (clickFilterStatus || clickFilterSearch || paginationChanged) {
      setIsLoading(true);
      debouncedDispatch(jobsGet, jobRequests);
    }

    return () => {
      debouncedDispatch.cancel();
    };
  }, [
    jobRequests,
    clickFilterStatus,
    clickFilterSearch,
    paginationChanged,
    debouncedDispatch,
  ]);

  const handleSelectedJob = (item: any) => {
    dispatch(selectedJob(item));
  };
  const handleDeleteJob = (data: any) => {
    handleDeleteJobService(
      data,
      jobRequests,
      setIsLoading,
      dispatch,
      addAlert,
      false,
      navigate,
      jobsGet,
      protectedResources
    );
  };

  const handleSetFilteredValue = (inputValue: string) => {
    setClickFilterStatus(false);
    setClickFilterSearch(true);
    if (inputValue.length === 0) {
      setJobRequest((prevState) => ({
        ...prevState, // copy the previous state
        SearchText: "", // update the SearchText property
      }));
    } else {
      setJobRequest((prevState) => ({
        ...prevState, // copy the previous state
        SearchText: inputValue, // update the SearchText property
      }));
    }
  };

  const handlePageChange = (event: any) => {
    setPaginationChanged(true);
    setIsLoading(true);
    const { selected } = event;
    setJobRequest((prevState) => ({
      ...prevState, // copy the previous state
      PageNumber: selected + 1, // update the pageNumber
    }));
  };

  return (
    <Container fluid className="layout-bar">
      <BreadCrumb />

      <Headline name="Jobs" subHeading="Keep track of every job in one place" />

      <div className="content-wrapper">
        <div className="filter-wrapper">
          <FilterSection handleSetFilteredValue={handleSetFilteredValue} />

          <Link to="/jobs/add-job" >
            <Button cssClass="btn-primary" text="Add New Job" />
          </Link>
        </div>
      </div>
      <div className="content-wrapper">
        {isLoading ? (
          <Loader />
        ) : (
          <>
            {requestedJobs &&
            requestedJobs.data &&
            requestedJobs.data.length > 0 ? (
              requestedJobs.data.map((user: any, index: number) => (
                <div onClick={(e) => handleSelectedJob(user)} key={index}>
                  <FullWidthCard
                    cardContent={JobCardContent as CardContentItem[]}
                    key={index}
                    data={user}
                    deleteCard={handleDeleteJob}
                  />
                </div>
              ))
            ) : (
              <SearchHelper
                userdata={requestedJobs}
                isLoading={isLoading}
                filteredValue={[]}
                status={status}
              />
            )}
          </>
        )}
        {requestedJobsData?.totalPages > 1 ? (
          <Pagination
            pageCount={requestedJobs.totalPages}
            pageNumber={jobRequests.PageNumber}
            onPageChange={(page: number) =>
              handlePageChange({ selected: page - 1 })
            }
            totalPages={requestedJobs.totalPages}
            pageSize={jobRequests.PageSize}
            totalRecords={requestedJobs.totalRecords}
            label="jobs"
          />
        ) : null}
      </div>
    </Container>
  );
};

export default ListOfJobs;
